import { memo } from 'react';
import { useFirestore } from '@client/hooks/utils.hooks';
import { upsertVenue } from '@client/slices/entities/venues.reducer';
import { getVenueById } from '@client/selectors/entities/venues';
import { ProfileTypes } from '@sda/enums';
import { ReviewProfile } from './ReviewProfile';
import { ProfileSkeleton } from './ProfileSkeleton';

interface VenueProps {
  readonly venueId: string;
  readonly disableProfileClick?: boolean;
  readonly showId?: string;
}

export const Venue = memo<VenueProps>(({ venueId, disableProfileClick, showId }) => {
  const [profile, isLoading] = useFirestore(
    (SDK) => SDK.Venues.get(venueId),
    {
      key: venueId,
      upserter: upsertVenue,
      selector: getVenueById,
    },
  );

  if (!profile || isLoading) {
    return <ProfileSkeleton />;
  }

  return (
    <ReviewProfile
      selectedProfileId={venueId}
      selectedProfileType={ProfileTypes.VENUE}
      disableProfileClick={disableProfileClick}
      showId={showId}
      {...profile}
    />
  );
});
